import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";


export const getTerritoryList = async(params:Record<string,any>)=>{
    let response = await axiosInstance.get(API_ENDPOINTS.Terrritoris.GET_TERRITORIS_LIST,{params:params});
    return response?.data;   
}

export const getTerritoryById = async(params:Record<string,any>)=>{
    let response = await axiosInstance.get(API_ENDPOINTS.Beat.GET_TERRITORY_BY_ID,{params});
    return response?.data;   
}

export const getPositionList = async (OrgUnitId:number |null,TerritoryId:number | null)=>{
   const query = `?OrgUnitId=${OrgUnitId ?? 0}&TerritoryId=${TerritoryId}`;
    const response = await axiosInstance.get(`${API_ENDPOINTS.Terrritoris.GET_POSITION_LIST}${query}`);
    return response?.data;
}

export const addTerritory = async (ReqBody={})=>{
  const url = `${API_ENDPOINTS.Terrritoris.POST_ADD_TERRIORTY}`
 let response = await axiosInstance.post(url,ReqBody);
}

export const updateTerritory = async (ReqBody={}, id:number| null)=>{

  const url  =`${API_ENDPOINTS.Terrritoris.PUT_UPADATE_TERRITORY}/${id}`;
  let response = await axiosInstance.put(url,ReqBody);
  
}
   


/*****************************************************************Towns************************************************************* */

export const getTerritoryTownList = async (params: Record<string, any>, id: number | null) => {
  const url = `${API_ENDPOINTS.Terrritoris.GET_TERRITORIS_TOWN_LIST}/${id}`;
  const response = await axiosInstance.get(url,{ params });
  return response?.data;
};




export const getAssignTripTypes = async()=>{
   try{
     let response = await axiosInstance.get(API_ENDPOINTS.Terrritoris.GET_ASSIGNTOTRIP_TYPES);
     const rowData = response?.data?.data;
    const data = rowData && typeof rowData ==='object' && !Array.isArray(rowData)
    ? Object.entries(rowData).map(([id,label])=>({
      id:id,
      label:String(label)
    })):[]
    return data; 
   }catch(error:any){
    console.log(`Something went wrong ${error.message}`); 
   }
}


export const getOtherTripTypes = async ()=>{
  try{
  let response  = await axiosInstance.get(API_ENDPOINTS.Terrritoris.GET_OTHERS_TRIP_TYPES);
  
  const rowData = response?.data?.data;
  const data = rowData && typeof rowData ==='object' && !Array.isArray(rowData)
   ?Object.entries(rowData).map(([id,label])=>({
      id:id,
      label:String(label)
   })):[]
    return data;
  }
  catch(error:any){
    console.log(`Somthing Went Wrong  ${error.message}`);
  }
}

export const getSearchLocation = async (userQuery: string) => {
  const query = `?term=${userQuery}`;
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.Terrritoris.GET_SEARCH_LOCATIONS}${query}`
  );

 const filterData = Array.isArray(response?.data?.data)
  ? response?.data?.data?.map((item: any) => ({
      id: item?.id,
      label: item?.label,
    }))
  : [];
   return filterData
};

export const addTerritoryTown = async(ReqBody={})=>{
    const url = `${API_ENDPOINTS.Terrritoris.POST_ADD_TERRITORY_TOWN}`
    let response  = await axiosInstance.post(url,ReqBody) 
}

export const updateTerritoryTown = async(ReqBody={})=>{
  const url = `${API_ENDPOINTS.Terrritoris.PUT_UPDATE_TERRITORY_TOWN}`;
  let response = await axiosInstance.put(url,ReqBody); 
}